import terminateAddinNavigationOperation from './terminateAddinNavigationOperation';
import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getPreviousNavigationState, setPreviousNavigationState } from '../PreviousNavigationState';
import { sendItemNullEvent } from '../SendItemEvent';
import { TaskPaneErrorType } from 'owa-addins-store';
import { updatePersistentTaskPaneError } from 'owa-addins-store';

export default function sendErrorToAddinNavigationOperation(errorType: TaskPaneErrorType) {
    const prevNavState = getPreviousNavigationState();

    if (
        prevNavState.mode === ExtensibilityModeEnum.MessageCompose ||
        prevNavState.mode === ExtensibilityModeEnum.Unknown
    ) {
        terminateAddinNavigationOperation();
        return;
    }

    updatePersistentTaskPaneError(errorType);
    if (!prevNavState.isNullSent) {
        sendItemNullEvent();
        setPreviousNavigationState({
            hostItemIndex: null,
            mode: ExtensibilityModeEnum.MessageRead,
            isNullSent: true,
        });
    }
}
